import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import VoucherStudio from "@/components/vouchers/VoucherStudio";

const ManualVouchers = ({ canDelete = true }) => {
  const { user } = useAuth();
  return (
    <div data-testid="admin-manual-vouchers-page">
      <VoucherStudio client={api} base="/admin/vouchers/manual" listPath="/admin/vouchers/manual"
        trainerName={user?.name && user.name !== "Administrator" ? user.name : "Michael Wolf"} canDelete={canDelete} />
    </div>
  );
};

export default ManualVouchers;
